<template>
  <div class="ev-timeline__wrapper">
    <div class="ksm-timeline__vonbis-wrapper">
      <div style="padding:0 5px">von</div>
      <!-- <div class="ksm-timeline__vonbis-item"> -->
      <div style="padding:0 5px">
        <Datepicker
          lang="de"
          :format="dateVonFormat"
          value-type="timestamp"
          width="auto"
          :append-to-body="true"
          placeholder
          :clearable="false"
          :editable="true"
          input-class="ksm-timeline__vonbis-item"
          @change="changeDatepicker"
          v-model="vonDatum"
          :not-before="notDayBefore"
          :not-after="notDayAfter"
          :confirm="true"
        ></Datepicker>
      </div>
      <!-- </div> -->
      <div style="padding:0 5px">bis</div>
      <div style="padding:0 5px">
        <Datepicker
          lang="de"
          :clearable="false"
          :format="dateVonFormat"
          value-type="timestamp"
          width="auto"
          :append-to-body="true"
          placeholder
          :editable="true"
          @change="changeDatepicker"
          input-class="ksm-timeline__vonbis-item"
          v-model="bisDatum"
          :not-before="notDayBefore"
          :not-after="notDayAfter"
          :confirm="true"
        ></Datepicker>
      </div>
    </div>
    <div ref="svg-container" class="ev-timeline__svg-container" :style="'height:'+height+'px'">
      <span
        v-if="hoverItems"
        style="width:0; height:0; z-index:2000;position:absolute;"
        :style="tooltipStyle"
      >
        <span v-tooltip="tooltipOption"></span>
        <!-- <div
          v-for="(infoItem,i) of hoverItems"
          :key="i"
          style="display:block"
        >{{infoItem.row._datvon}}{{infoItem.row._datbis?(' &ndash; '+infoItem.row._datbis):''}}{{infoItem.row.stadtname}} {{infoItem.row.ortsname}}</div>-->
      </span>
      <div class="ev-timeline_zoombtn-wrapper">
        <div
          class="ev-timeline_zoombtn"
          :class="{'zoombtn-disable':zoomVal>=50}"
          @click="zoomClick(2);"
        >+</div>
        <div
          class="ev-timeline_zoombtn"
          :class="{'zoombtn-disable':zoomVal<=1}"
          @click="zoomClick(0.5);"
        >-</div>
      </div>
      <svg
        ref="ev_corr-svg"
        width="100%"
        preserveAspectRatio="xMinYMin meet"
        height="100%"
        class="ev-timeline__svg"
      >
        <g ref="background_container" class="background_container" />
        <g ref="content_container" class="content_container" />
        <defs>
          <clipPath ref="clipPath">
            <rect ref="clipPath_rect" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import * as moment from "moment";
import { mergeInterval, timelineTickFormat } from "../utils/utils";
import Datepicker from "vue2-datepicker";

/*
 * Timeline für Briefwechsel (briefWechsel) und Listview
 * zwei Type:
 * briefWechsel: fullDoc
 * listView :toolbarItemData._filteredDocuments
 */

export default {
  props: [
    "fullDoc",
    "toolbarItemData",
    "type",
    "infoItemList",
    "activeInfoItem",
    "splitLayoutResize"
  ],
  data() {
    return {
      tooltipStyle: "",
      tooltipOption: {
        show: true,
        content: "",
        placement: "top-center",
        classes: ["timeline-info"],
        offset: 10,
        delay: {
          show: 0,
          hide: 0
        }
      },
      // timelineMap: null,
      timelineData: null, //nur Desktopsuche list
      hoverItems: null,
      brushSelection: null, //nur Desktopsuche list
      // mergeData: null,
      briefWechselData: null, //nur Briefwechsel
      // mouseoverG: null, //nur Briefwechsel
      senderTimelineData: null, //nur Briefwechsel
      receiverTimelineData: null, //nur Briefwechsel
      initSenderId: null, //nur Briefwechsel,
      leftSide: 10,
      width: null,
      height: 75,
      rightSide: 5,
      rectHeight: 25,
      lineY: 40,
      minDate: null,
      maxDate: null,
      currentTransform: null,
      zoomScaleExtent: [1, 50],
      zoomScale: null,
      zoomVal: 0,
      origScale: null,
      w: 0,
      timerId: null,
      showLoading: true,
      vonbis: null,
      zooming: false,
      zoomBrush: null,
      zoomEventFromBrush: false,
      vonDatum: null,
      bisDatum: null,
      notDayBefore: null,
      notDayAfter: null,
      dateVonFormat: {
        stringify: date => {
          return date ? moment(date).format("DD.MM.YYYY") : null;
        },
        parse: value => {
          if (value) {
            value = value + "";
            const len = value.split(".").length;
            if (len == 1) {
              value = "01.01." + value;
            } else if (len == 2) {
              value = "01." + value;
            }
          }
          return value ? moment(value, "DD.MM.YYYY") : null;
        }
      },
      dateBisFormat: {
        stringify: date => {
          return date ? moment(date).format("DD.MM.YYYY") : null;
        },
        parse: value => {
          if (value) {
            value = value.replace(/[,-\/]/g, ".");
            value = value + "";
            const len = value.split(".").length;
            if (len == 1) {
              value = "31.12." + value;
            } else if (len == 2) {
              return moment(value, "MM.YYYY").endOf("month");
            }
          }
          return value ? moment(value, "DD.MM.YYYY") : null;
        }
      }
    };
  },
  components: {
    Datepicker
  },
  computed: {
    a_baseDocuments() {
      if (!this.toolbarItemData || !this.toolbarItemData._baseProjects) {
        return;
      }
      return this.$store.getters.getDocumentsByProjectIds(
        this.toolbarItemData._baseProjects.map(p => p.id)
      );
    },
    isBriefWechsel() {
      return this.type === "briefWechsel";
    }
  },
  watch: {
    a_baseDocuments() {
      if (!this.isBriefWechsel) {
        this.a_initData();
      }
    },
    hoverItems(hoverItems) {
      let t = "";
      if (hoverItems) {
        hoverItems.forEach(it => {
          const row = it.row;
          const dateStr =
            row._datvon + " " + (row._datbis ? " &ndash; " + row._datbis : "");
          t +=
            '<div class="ksm-flex"><div class="ksm-map__fenster-item-icon" style="background-color:' +
            it.accor.color +
            '"></div><div class="ksm-flex-1">' +
            dateStr +
            "</div></div>";
          t +=
            "<div>" +
            (row.stadtname ? row.stadtname : "") +
            " " +
            (row.ortsname ? row.ortsname : "") +
            "</div>";
          t += "<div>" + row.short_113_html + "</div>";
          t = '<div style="margin-bottom:10px">' + t + "</div>";
        });
      }
      this.tooltipOption.content = t;
      //  const otherSameDay = this.infoItemList.find(
      //   d => d.row.datvon === datvon && d !== hoverItems.item
      // );
      // console.log(otherSameDay)
    },
    activeInfoItem(d) {
      this.drawActiveInfoItem(d, "selected");
    },
    splitLayoutResize() {
      const vue = this;
      setTimeout(function() {
        vue.drawAll();
      }, 300);
    }
  },
  mounted: function() {
    // if (this.isBriefWechsel) {
    //   this.b_fetchBriefWechselData();
    // } else {
    this.a_initData();
    // }
    const vue = this;
    setTimeout(function() {
      vue.showLoading = false;
    }, 5000);
  },
  methods: {
    a_initData() {
      const vue = this;
      const infoItemList = this.infoItemList;
      if (!infoItemList || infoItemList.length == 0) {
        return;
      }
      // console.time("a_initData");
      const parseTime = d3.timeParse("%Y-%m-%d");
      // const map = new Map();
      const list = this.infoItemList
        .map(doc => {
          const d = parseTime(doc.row.datvon);
          // map.set(doc.row.docID, d);
          return {
            item: doc,
            date: d
          };
        })
        .sort((a, b) => {
          return a.date - b.date;
        });

      // vue.timelineMap = map;
      vue.minDate = list[0].date;
      vue.maxDate = list[list.length - 1].date;
      vue.timelineData = list;
      vue.showLoading = false;
      vue.drawAll();
      window.addEventListener("resize", function() {
        vue.drawAll();
      });
    },

    a_brushended() {
      if (this.zooming) {
        return;
      }
      const selection = d3.event.selection;
      if (!d3.event.sourceEvent) return; // Only transition after input.
      if (!selection) return; // Ignore empty selections.
      this.brushSelection = selection;
      this.a_dispatchDateChanged();
    },

    a_debounce(fn, wait) {
      wait = wait || 0;
      const vue = this;
      let timerId = this.timerId;
      function a_debounced() {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }
        timerId = setTimeout(function() {
          fn();
        }, wait);
        vue.timerId = timerId;
      }

      return a_debounced;
    },

    a_dispatchDateChanged() {
      if (this.isBriefWechsel) {
        return;
      }
      let brushSelection = this.brushSelection;
      if (!brushSelection) {
        const rect = this.brushContainer.select("rect.selection");
        const xVon = rect.attr("x");
        const xBis = -(-xVon - rect.attr("width"));
        brushSelection = [xVon, xBis];
      }

      const vue = this;
      const scale = this.zoomScale || this.origScale;
      const vonbis = brushSelection.map(scale.invert);
      this.vonbis = vonbis;
      this.a_setBrushText(vonbis);

      const vonStr = moment(vonbis[0]).format("YYYY-MM-DD");
      const bisStr = moment(vonbis[1]).format("YYYY-MM-DD");
      const set = new Set();
      this.infoItemList
        .filter(it => {
          return it.row.datvon >= vonStr && it.row.datvon <= bisStr;
        })
        .forEach(it => {
          set.add(it.row.stadtindex);
        });

      setTimeout(function() {
        vue.$emit("changeDate", [...set]);
      }, 1);
    },

    emptySvg() {
      d3.select(this.$refs["background_container"])
        .selectAll("*")
        .remove();
      d3.select(this.$refs["content_container"])
        .selectAll("*")
        .remove();
    },

    zoomClick(val) {
      this.zoom.scaleBy(this.zoomRect.transition().duration(500), val);
    },

    zoomed() {
      const vue = this;
      let transform = d3.event.transform;
      this.currentTransform = transform;
      const height = this.divContainer.clientHeight;
      const origScale = vue.origScale;
      const zoomScale = transform.rescaleX(origScale);
      this.xAxisContainer.call(vue.xAxis.scale(zoomScale));
      this.zoomScale = zoomScale;
      this.datebarContainer.selectAll(".ev-timeline__date-g").remove();
      // this.mouseoverG.attr("class", "ev-timeline__mouseover-g--hide");
      this.zoomVal = transform.k;

      if (!this.isBriefWechsel) {
        let vonbis = this.vonbis;
        if (!vonbis) {
          vonbis = d3.brushSelection(this.brushContainer.node());
          vonbis = vonbis.map(origScale.invert);
          this.vonbis = vonbis;
        }
        const [xx, yy] = origScale.domain().map(zoomScale);
        this.zooming = true;
        this.brush.extent([[xx, 0], [yy, height]]);
        this.brushContainer.call(this.brush);
        this.brush.move(this.brushContainer, vonbis.map(zoomScale));
        this.zooming = false;
      }

      this.beforeDrawDateBar();
      // this.a_dispatchDateChanged();
    },

    drawAll() {
      if (this.$route.name == "orteundwege" && this.$el.clientWidth > 0) {
        this.emptySvg();
        this.initTimeline();
        this.beforeDrawDateBar();
      }
    },

    beforeDrawDateBar() {
      const xScale = this.zoomScale || this.origScale;
      // this.mergeData = this.drawDateBar(xScale, this.timelineData);
      this.drawDateBar(xScale, this.timelineData);
      this.drawActiveInfoItem(this.activeInfoItem, "selected");
    },

    drawActiveInfoItem(activeInfoItem, className) {
      className = "ev-timeline__date-g--" + className;
      this.datebarContainer.selectAll("." + className).remove();
      if (!activeInfoItem) {
        return;
      }
      const datvon = activeInfoItem.row.datvon;
      const _h = this.rectHeight;
      //draw selected rect
      const xScale = this.zoomScale || this.origScale;
      const selected = d3.timeParse("%Y-%m-%d")(activeInfoItem.row.datvon);
      const x = xScale(selected) - 2;
      const g = this.datebarContainer
        .append("g")
        .attr("class", "ev-timeline__date-g " + className)
        .attr("transform", "translate(" + x + ",5)");

      g.append("rect")
        .attr("fill", activeInfoItem.accor.color)
        .attr("pointer-events", "all")
        .attr("height", _h + 10)
        .attr("width", 5);

      const otherSameDay = this.infoItemList.find(
        d => d.row.datvon === datvon && d !== activeInfoItem
      );

      if (otherSameDay) {
        let _h2 = (_h + 10) / 2;
        let y = 0;
        if (otherSameDay.accor.id === "merzabende") {
          y = _h2;
        }
        g.append("rect")
          .attr("fill", otherSameDay.accor.color)
          .attr("pointer-events", "none")
          .attr("y", y)
          .attr("height", _h2)
          .attr("width", 5);
      }
    },

    drawDateBar(xScale, data, className, rectHeight) {
      const vue = this;
      if (!data) {
        return [];
      }
      if (!className) {
        className = "";
      }
      if (!rectHeight) {
        rectHeight = vue.rectHeight;
      }
      const w = this.width;

      const von = xScale.invert(0);
      const bis = xScale.invert(w);
      let ranges = [];
      data.forEach(doc => {
        const d = doc.date;
        if (d < von || d > bis) {
          return;
        }
        const x = xScale(d);
        if (x < 0 || x > w) {
          return;
        }
        ranges.push([x, x + 5, doc]);
      });

      // if (ranges.length > 500) {
      // ranges = mergeInterval(ranges);
      // }
      let activeX = 0;
      this.datebarContainer
        .selectAll("aa")
        .data(ranges)
        .enter()
        .append("g")
        .attr("class", "ev-timeline__date-g " + className)
        .attr("transform", function(d) {
          const t = d3.select(this);
          t.append("rect")
            .attr("class", "ev-timeline__datebar")
            // .attr("pointer-events", "none")
            .attr("height", rectHeight)
            .attr("width", d[1] - d[0])
            .attr("transform", function() {
              return "translate(0,15)";
            });
          return "translate(" + (d[0] - 2) + ",0)";
        });

      return ranges;
    },

    getMouseOverItems(x) {
      const vue = this;
      const scale = vue.zoomScale || vue.origScale;
      let item = null;
      let out = null;
      const parseTime = d3.timeParse("%Y-%m-%d");
      vue.timelineData.forEach(td => {
        const tx = scale(td.date);
        if (x - 2 < tx && tx < x + 2) {
          item = td.item;
        }
      });

      if (item) {
        out = [item];
        const other = vue.infoItemList.find(d => {
          return d.row.datvon === item.row.datvon && d !== item;
        });
        if (other) {
          out.push(other);
        }
      }
      vue.hoverItems = out;
      return out;
    },

    a_setBrushText(vonbis) {
      const vue = this;
      const w = this.w;
      const rect = vue.brushContainer.select("rect.selection");
      let xVon = rect.attr("x");
      let xBis = -(-xVon - rect.attr("width"));
      let vonStr = "";
      let bisStr = "";
      let invalid = false;
      if (!xVon || !xBis) {
        invalid = true;
      } else {
        //set text
        if (!vonbis) {
          const scale = vue.zoomScale || vue.origScale;
          vonbis = [xVon, xBis].map(scale.invert);
        }
        vonStr = moment(vonbis[0]).format("DD.MM.YYYY");
        bisStr = moment(vonbis[1]).format("DD.MM.YYYY");
      }

      vue.vonDatum = moment(vonbis[0]);
      vue.bisDatum = moment(vonbis[1]);
      // vue.$store.commit("updateObject", {
      //   obj: vue.toolbarItemData,
      //   key: "__timeBrushString",
      //   val: [vonStr, bisStr].join("--")
      // });
      return;
      if (invalid) {
        return;
      }

      //set x koordination
      const dist = vue.textvon.node().getBBox().width;

      vue.textvon.attr("x", xVon - dist < 0 ? 5 : xVon - dist - 5);
      vue.textbis.attr("x", xBis >= w - dist ? w - dist - 5 : xBis + 5);
    },

    changeDatepicker() {
      const dVon = new Date(this.vonDatum);
      const dBis = new Date(this.bisDatum);
      const scale = this.zoomScale || this.origScale;
      this.brushContainer.call(this.brush.move, [dVon, dBis].map(scale));
    },

    initTimeline() {
      const svg = this.$refs["ev_corr-svg"];
      if (!svg) {
        return;
      }

      if (this.isBriefWechsel) {
        if (!this.senderTimelineData && !this.receiverTimelineData) {
          return;
        }
      } else if (!this.timelineData) {
        return;
      }

      const divContainer = this.$refs["svg-container"];
      this.divContainer = divContainer;
      this.width = divContainer.clientWidth;
      const vue = this;
      const lineY = this.lineY;

      const rootG = d3.select(this.$refs["background_container"]);
      //add line
      rootG
        .append("line")
        .attr("class", "separator-line")
        .attr("x1", 0)
        .attr("y1", lineY)
        .attr("x2", vue.width)
        .attr("y2", lineY);

      const w = vue.width - vue.rightSide - vue.leftSide;
      const h = divContainer.clientHeight;
      this.w = w;

      //clipPath
      const clipPathId = "clip_ortundwege";
      d3.select(vue.$refs["clipPath"]).attr("id", clipPathId);
      d3.select(vue.$refs["clipPath_rect"])
        .attr("width", w)
        .attr("height", h);

      //data container
      const contentContainer = d3.select(this.$refs["content_container"]);
      contentContainer.attr("clip-path", "url(#" + clipPathId + ")");
      vue.contentContainer = contentContainer;

      const diff = this.isBriefWechsel ? 1 : 2;
      const origScale = d3
        .scaleTime()
        .range([0, w])
        .domain([
          moment(vue.minDate).subtract(diff, "years"),
          moment(vue.maxDate).add(diff, "years")
        ]);
      vue.origScale = origScale;
      vue.notDayBefore = origScale.domain()[0];
      vue.notDayAfter = origScale.domain()[1];
      const xAxis = d3
        .axisBottom()
        .scale(origScale)
        .tickFormat(timelineTickFormat)
        .tickSizeOuter(0)
        .tickSizeInner(10);

      vue.xAxis = xAxis;

      // add datebar Container
      // vue.datebarContainer = contentContainer
      //   .append("g")
      //   .attr("class", "ev-timeline__date-container");

      // add x axis
      const axisOffsetY = lineY;
      vue.xAxisContainer = contentContainer
        .append("g")
        .attr("class", "x axis")
        .call(xAxis)
        .attr("transform", "translate(0," + axisOffsetY + ")");

      //add zoom rect container
      const zoom = d3
        .zoom()
        .translateExtent([[0, 0], [w, h]])
        .extent([[0, 0], [w, h]])
        .scaleExtent(vue.zoomScaleExtent)
        .on("zoom", function() {
          if (vue.isBriefWechsel) {
            vue.zoomed();
            return;
          }
          if (this.tagName.toLowerCase() === "g") {
            if (!vue.zoomEventFromBrush) {
              vue.zoomEventFromBrush = true;
            } else {
              zoom.transform(vue.zoomRect, d3.event.transform);
            }
            return;
          } else {
            vue.zoomEventFromBrush = false;
            zoom.transform(vue.zoomBrush, d3.event.transform);
            vue.zoomed();
          }
        });

      const zoom2 = d3
        .zoom()
        .translateExtent([[0, 0], [w, h]])
        .extent([[0, 0], [w, h]])
        .scaleExtent(vue.zoomScaleExtent)
        .on(
          "zoom",
          function() {
            if (!vue.zoomEventFromBrush) {
              vue.zoomEventFromBrush = true;
              return;
            }
            zoom.transform(vue.zoomRect, d3.event.transform);
          },
          true
        );

      vue.zoom = zoom;
      //zoom rect
      vue.zoomRect = contentContainer
        .append("rect")
        .attr("class", "ev-timeline__zoom-rect")
        .attr("width", w)
        .attr("height", h)
        .on("wheel", function() {
          //scroll nach unten vermeiden
          d3.event.preventDefault();
        })
        .call(zoom);

      //wenn Briefwechsel
      // if (vue.isBriefWechsel) {
      // const mouseoverG = contentContainer
      //   .append("g")
      //   .attr("class", "ev-timeline__mouseover-g--hide");

      // mouseoverG
      //   .append("rect")
      //   .attr("width", 1)
      //   .attr("y", 10)
      //   .attr("height", vue.rectHeight + 17)
      //   .attr("pointer-events", "none");

      // mouseoverG
      //   .append("text")
      //   .attr("class", "ev-timeline__brush-label")
      //   .attr("x", 0)
      //   .attr("y", 10);

      //Brief wechseln mit Anklick
      // vue.zoomRect.on("click", function() {
      //   const scale = vue.zoomScale || vue.origScale;
      //   let x = d3.mouse(this)[0];
      //   const d = scale.invert(x);
      //   const dt = d.getTime();
      //   let min = Math.abs(dt);
      //   x = x + 5;
      //   if (!vue.mergeData.find(d => d[0] <= x && x <= d[1])) {
      //     return;
      //   }
      //   let item = null;
      //   const parseTime = d3.timeParse("%Y-%m-%d");
      //   vue.infoItemList.forEach((doc, i) => {
      //     const d = parseTime(doc.row.datvon);
      //     const dist = Math.abs(d.getTime() - dt);
      //     if (dist < min) {
      //       min = dist;
      //       item = doc;
      //     }
      //   });
      //   vue.$emit("clickInfoItem", item);
      // });

      //Line für Briefauswahl
      // vue.zoomRect
      //   .on("mousemove", function() {
      //     const scale = vue.zoomScale || vue.origScale;
      //     let x = d3.mouse(this)[0];
      //     const d = scale.invert(x);
      //     const dt = d.getTime();
      //     let min = Math.abs(dt);
      //     x = x + 5;

      //     return;
      //     //mouseover schieben
      //     mouseoverG.attr("transform", "translate(" + x + ",0)");
      //     mouseoverG.attr("class", "ev-timeline__mouseover-g");
      //     const dateList = [...vue.timelineMap.values()];
      //     const t = mouseoverG.select("text");
      //     if (!vue.mergeData.find(d => d[0] <= x && x <= d[1])) {
      //       t.text(moment(dt).format("DD.MM.YYYY"));
      //       t.attr("x", -t.node().getBBox().width / 2);
      //       return;
      //     } else {
      //       let dateText = "";
      //       const parseTime = d3.timeParse("%Y-%m-%d");
      //       vue.infoItemList.forEach(doc => {
      //         const d = parseTime(doc.row.datvon);
      //         const dist = Math.abs(d.getTime() - dt);
      //         if (dist < min) {
      //           min = dist;
      //           dateText = moment(d).format("DD.MM.YYYY");
      //         }
      //       });
      //       t.text(dateText);
      //       t.attr("x", -t.node().getBBox().width / 2);
      //     }
      //   })
      //   .on("mouseout", function() {
      //     mouseoverG.attr("class", "ev-timeline__mouseover-g--hide");
      //   });
      // vue.mouseoverG = mouseoverG;
      // }

      //add brush container
      if (!this.isBriefWechsel) {
        const brush = d3
          .brushX()
          .extent([[0, 0], [w, h]])
          .on("brush", function() {
            vue.a_setBrushText();
            vue.a_brushended();
          });
        // .on("end", this.a_brushended);

        vue.brush = brush;

        const zoomBrush = contentContainer.append("g").call(zoom);
        this.zoomBrush = zoomBrush;
        const brushContainer = zoomBrush
          .append("g")
          .attr("class", "ev-timeline__brush-container")
          .on("wheel", function() {
            // d3.event.preventDefault();
          })
          .call(brush);
        vue.brushContainer = brushContainer;
        brushContainer.select("rect.overlay").attr("pointer-events", "none");
        brushContainer.select("rect.selection").attr("pointer-events", "auto");

        vue.textvon = brushContainer
          .append("text")
          .attr("class", "ev-timeline__brush-label")
          .attr("y", 12)
          .text("");

        vue.textbis = brushContainer
          .append("text")
          .attr("class", "ev-timeline__brush-label")
          .attr("y", 12)
          .text("");

        let moveExtent = null;
        if (
          !this.isBriefWechsel &&
          this.toolbarItemData &&
          this.toolbarItemData.timeDomain
        ) {
          const [d0, d1] = this.toolbarItemData.timeDomain.map(
            d3.timeParse("%Y-%m-%d")
          );
          if (d0 !== undefined && d1 !== undefined) {
            moveExtent = [d0, d1].map(origScale);
          }
        }

        if (!moveExtent) {
          if (vue.minDate === vue.maxDate) {
            moveExtent = [5, w - 5];
          } else {
            moveExtent = [
              origScale(moment(vue.minDate)),
              origScale(moment(vue.maxDate))
            ];
          }
        }
        brushContainer.call(brush.move, moveExtent);
      }

      contentContainer
        .on("mousemove", function() {
          const x = d3.mouse(this)[0];
          const items = vue.getMouseOverItems(x);
          if (items) {
            vue.tooltipStyle = "left:" + x + "px;";
            vue.drawActiveInfoItem(items[0], "hover");
          } else {
            vue.drawActiveInfoItem(null, "hover");
            vue.tooltipStyle = "display:none";
          }
        })
        .on("click", function() {
          if (vue.hoverItems) {
            vue.$emit("clickInfoItem", vue.hoverItems[0]);
          }
        });

      // return;
      vue.datebarContainer = contentContainer
        .append("g")
        .attr("class", "ev-timeline__date-container");
    }
  }
};
</script>

<style lang="scss">
.ev-timeline__wrapper {
  .ev-timeline__svg-container {
    background-color: #eeeded;
    // padding: 1px 10px;
    position: relative;
  }
}

.ev-timeline__datebar {
  // fill: $ev-primary-color;
  fill: rgb(30, 83, 107);
  &.mouseovered {
    fill: red;
  }
}

.ev-timeline__svg .x.axis path {
  display: none;
}

.ev-timeline__name {
  font-size: 9pt;
}

.ev-timeline__svg .separator-line {
  stroke: rgb(167, 162, 162);
  stroke-width: 1;
}

.ev-timeline_zoombtn-wrapper {
  @extend .ksm-flex__content--justify;
  @extend .g-select-disable;
  bottom: 5px;
  left: 5px;
  position: absolute;
  width: 48px;
  height: 20px;

  .ev-timeline_zoombtn {
    @extend .ksm-flex-xy-center;
    box-sizing: border-box;
    padding: 0px;
    width: 22px;
    background-color: #fff;
    border: 1px solid darkgray;
    cursor: pointer;
    &:active:not(.zoombtn-disable) {
      background-color: darkgray;
    }

    &.zoombtn-disable {
      opacity: 0.3;
    }
  }
}

.ev-timeline__zoom-rect {
  fill: none;
  pointer-events: all;
  // cursor: ew-resize;
}

.ev-timeline__brush-container {
  // pointer-events: none;
  rect {
    &.overlay {
      pointer-events: none;
      opacity: 0.3;
    }
    &.selection {
      fill: rgba(221, 165, 165, 0.61);
      // stroke:$blue1;
      pointer-events: auto;
      // height: 20;
      // y: 10;
    }
    &.handle {
      cursor: col-resize;
      pointer-events: all;
      // fill: $blue2;
    }
  }
}

.ev-timeline__date-g {
  pointer-events: all;
}

.ev-timeline__person {
  font-size: 10pt;
}

.ev-timeline__brush-label {
  fill: gray;
  font-size: 8pt;
}

.ev-timeline__mouseover-g {
  rect {
    fill: gray;
  }
}
.ev-timeline__mouseover-g--hide {
  display: none;
}

.ev-timeline__date-g.active {
  rect {
    fill: gray;
  }
}

.ksm-timeline__vonbis-wrapper {
  @extend .ksm-flex-y-center;
  // width: 17em;
  height: 28px;
  // border: 1px solid #c4cad1;
  margin-top: -1.5em;
  padding: 0;
  div {
    background-color: #c4cad1;
    height: 100%;
    text-align: center;
  }

  .ksm-timeline__vonbis-item {
    // @extend .ksm-flex-1;
    background-color: #fff;
    @extend .ksm-flex-xy-center;
    width: 8em;
    border-radius: 2px;
    padding: 0 5px;
    margin: auto 2px;
    .mx-input-append {
      padding: 0 !important;
    }
  }
}

.ksm-map__fenster-item-icon {
  width: 10px;
  border-radius: 5px;
  margin: 0px 5px;
  height: 10px;
}
</style>


// WEBPACK FOOTER //
// Timeline.vue?8279e8fc